module.exports = __webpack_public_path__ + "site/img/18.ae7804fe.jpg";